import { useState } from "react";
import { Link } from "react-router-dom";
import { FeedPostMenu } from "../shared";

export default function ProductCard({ post, user, onAddToCart, onQuickView, onEdit, onPostDeleted }) {
  const [imageIndex, setImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const eshopData = post.eshopData || {};
  const images = post.images || [];
  const price = eshopData.price || {};

  const formatPrice = (amount, currency = "BRL") => {
    if (!amount) return "Grátis";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: currency,
    }).format(amount);
  };

  const getDiscount = () => {
    if (price.originalPrice && price.amount) {
      const discount = Math.round(
        ((price.originalPrice - price.amount) / price.originalPrice) * 100
      );
      return discount > 0 ? discount : null;
    }
    return null;
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;

    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(
          <svg key={i} viewBox="0 0 24 24" fill="#fbbf24" width="14" height="14">
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </svg>
        );
      } else if (i === fullStars && hasHalf) {
        stars.push(
          <svg key={i} viewBox="0 0 24 24" fill="#fbbf24" width="14" height="14">
            <path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" />
          </svg>
        );
      } else {
        stars.push(
          <svg key={i} viewBox="0 0 24 24" fill="#d1d5db" width="14" height="14">
            <path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" />
          </svg>
        );
      }
    }
    return stars;
  };

  const discount = getDiscount();

  return (
    <div
      className="eshop_product_card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setImageIndex(0);
      }}
    >
      {/* Product Image */}
      <div className="eshop_product_image">
        {images.length > 0 ? (
          <img src={images[imageIndex]?.url || images[imageIndex]} alt="" />
        ) : (
          <div className="eshop_no_image">
            <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
              <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
            </svg>
          </div>
        )}

        {/* Image Navigation Dots */}
        {images.length > 1 && isHovered && (
          <div className="eshop_image_dots">
            {images.slice(0, 5).map((_, i) => (
              <span
                key={i}
                className={i === imageIndex ? "active" : ""}
                onMouseEnter={() => setImageIndex(i)}
              />
            ))}
          </div>
        )}

        {/* Discount Badge */}
        {discount && (
          <span className="eshop_discount_badge">-{discount}%</span>
        )}

        {/* Quick Actions */}
        <div className={`eshop_quick_actions ${isHovered ? "visible" : ""}`}>
          <button
            className="eshop_quick_btn"
            onClick={(e) => {
              e.stopPropagation();
              onQuickView(post);
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
            </svg>
          </button>
          <button
            className="eshop_quick_btn favorite"
            onClick={(e) => e.stopPropagation()}
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
            </svg>
          </button>
          <FeedPostMenu
            post={post}
            onEdit={onEdit}
            onPostDeleted={onPostDeleted}
          />
        </div>

        {/* Out of Stock */}
        {eshopData.stock === 0 && (
          <div className="eshop_out_of_stock">
            <span>Esgotado</span>
          </div>
        )}
      </div>

      {/* Product Info */}
      <div className="eshop_product_info">
        <Link to={`/profile/${post.user.username}`} className="eshop_seller">
          {eshopData.seller?.name || post.user.first_name}
        </Link>

        <h3 className="eshop_product_name">
          {eshopData.productName || post.text || "Produto sem nome"}
        </h3>

        {/* Rating */}
        {eshopData.ratings?.average > 0 && (
          <div className="eshop_rating">
            <div className="eshop_stars">
              {renderStars(eshopData.ratings.average)}
            </div>
            <span className="eshop_rating_count">
              ({eshopData.ratings.count || 0})
            </span>
          </div>
        )}

        {/* Price */}
        <div className="eshop_price">
          {price.originalPrice && price.originalPrice !== price.amount && (
            <span className="eshop_original_price">
              {formatPrice(price.originalPrice, price.currency)}
            </span>
          )}
          <span className="eshop_current_price">
            {formatPrice(price.amount, price.currency)}
          </span>
        </div>

        {/* Shipping */}
        {eshopData.shipping?.freeShipping && (
          <span className="eshop_free_shipping">Frete Grátis</span>
        )}

        {/* Add to Cart Button */}
        <button
          className="eshop_add_to_cart"
          onClick={() => onAddToCart(post)}
          disabled={eshopData.stock === 0}
        >
          {eshopData.stock === 0 ? "Indisponível" : "Adicionar ao Carrinho"}
        </button>
      </div>
    </div>
  );
}
